<template>
	<div 
		class="modal fade" 
		id="payment-methods-modal"
	>
		<div class="modal-dialog" style="max-width: 800px">
			<div class="modal-content">
				<div class="modal-header px-5 py-4 mb-3">
					<h4 class="font-20 m-0 text-center">
						ADICIONAR FORMA DE PAGAMENTO
					</h4>
					<button 
						type="button" 
						class="position-absolute btn btn-light p-3 ps-r-0 ps-t-0 m-3"
						@click="CloseModal()"
					>
						<i class="far fa-times mx-1"></i>
					</button>
				</div>
				<div class="modal-body">
					<PaymentMethods 
						ref="payment_methods"
						:total="total"
						:payment_methods_props="payment_methods_props"
						@payment-methods-added="payment_methods = $event"
					/>
				</div>
				<div class="modal-footer mt-2">
					<button 
						id="finish"
						type="button"
						class="btn btn-primary p-3 px-4"
						@click="CloseModal(true)"
					>	
						CONTINUAR
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PaymentMethods from './PaymentMethods.vue'

export default {
	name: 'PaymentMethodsModal',
	components: {
		PaymentMethods
	},
	props: {
		total: {
			type: Number,
			default: 0
		},
		payment_methods_props: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			payment_methods: null
		}
	},
	methods: {
		async CloseModal(save_data = false) {
			if(save_data) {
				if(!await this.$refs.payment_methods.AddCurrentMethod()) {
					return;
				}

				this.$emit('payment-methods-added', this.payment_methods)
			}

			window.jQuery('#payment-methods-modal').modal('hide')
			window.jQuery('body').removeClass('modal-open')
		},
	}
}
</script>

<style>

</style>